// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:errors` (see frontend/package.json).
// Source: agent.shared.types.repository.PendingMergeError

import { RpcError, registerRpcError } from "@/app_store/rpc_error";

// Wire shape of this error: `code` discriminates the type, `message` is the
// human-readable text, and the remaining keys are the exception's own fields.
export interface PendingMergeErrorData {
    code: "PendingMergeError";
    message: string;
}

export class PendingMergeError extends RpcError {
    readonly code = "PendingMergeError" as const;

    constructor(data: PendingMergeErrorData) {
        super(data.code, data.message, data);
    }
}

registerRpcError("PendingMergeError", PendingMergeError);
